import { useState, useEffect, useRef } from "react";
import { Link } from "@/components/common/Link";
export default function StatisticsBlock() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  const stats = [{
    number: "+500",
    label: "IGLESIAS EN COSTA RICA",
    numberPill: true
  }, {
    number: "+600",
    label: "MINISTROS",
    numberPill: false
  }, {
    number: "5,713",
    label: "MISIONEROS",
    numberPill: true
  }, {
    number: "88,866,189",
    label: "ADHERENTES MUNDIALES",
    numberPill: true
  }, {
    number: "451,512",
    label: "IGLESIAS MUNDIALES",
    numberPill: false
  }];
  return <section ref={ref} style={{
    backgroundColor: "#F5F4F2",
    fontFamily: "Switzer, sans-serif"
  }} className="dark m-0 w-full overflow-hidden ![padding:30px_0px_64px_0px]">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Oswald:wght@400;500;600&family=Inter:wght@300;400;500;600&display=swap');
        
        @font-face {
          font-family: 'Switzer';
          src: local('Switzer');
        }
        
        .stat-number-pill {
          background-color: #FFFFFF;
          border-radius: 999px;
          padding: 4px 16px;
          color: #353533;
          display: inline-block;
          white-space: nowrap;
        }
        
        .stat-label-pill {
          background-color: #FFFFFF;
          border-radius: 999px;
          padding: 4px 16px;
          color: #353533;
          display: inline-block;
          white-space: nowrap;
        }
        
        .stat-number-plain {
          color: #FFFFFF;
          display: inline-block;
          white-space: nowrap;
        }
        
        .stat-label-plain {
          color: #FFFFFF;
          display: inline-block;
          white-space: nowrap;
        }
        
        .red-block {
          position: relative;
          background-color: #F73C4A;
          border-radius: 28px;
          overflow: hidden;
          width: 100%;
        }
        
        .stat-text {
          font-family: 'Switzer', 'Inter', sans-serif;
          font-size: clamp(18px, 2.2vw, 36px);
          font-weight: 400;
          line-height: 1.2;
          text-transform: uppercase;
          letter-spacing: -0.01em;
        }
      `}</style>

      <div className="w-full px-4 max-w-[1400px] mx-auto !h-[700px] md:px-10">
        <div className="red-block shadow-lg !bg-[rgba(247,60,74,0)]" style={{
        backgroundImage: 'url("https://current-thrush.10web.cloud/wp-content/uploads/2026/08/PORTADA.png")',
        backgroundSize: "cover",
        backgroundPosition: "center bottom",
        backgroundRepeat: "no-repeat",
        color: "rgb(33, 33, 31)"
      }}>
          <div className="flex flex-col justify-end p-6 min-h-[450px] w-full !h-[580px] md:p-14 md:min-h-[600px]">
            <div className="flex flex-col gap-3 md:gap-4 max-w-full md:max-w-[85%]">
              {stats.map((stat, index) => <div key={index} data-index={index} className="flex items-center gap-3 flex-wrap">
                  {stat.numberPill ? <>
                      <span className="stat-number-pill stat-text">{stat.number}</span>
                      <span className="stat-label-plain stat-text">{stat.label}</span>
                    </> : <>
                      <span className="stat-number-plain stat-text">{stat.number}</span>
                      <span className="stat-label-pill stat-text">{stat.label}</span>
                    </>}
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}